import './_article.scss';

export default () => {};
